import type { TOC } from '@ember/component/template-only';

interface HotelAndMarketRevenueInsightSegmentationSegmentationMetricBlockBarLoadingSignature {
  Args: {};
}

const HotelAndMarketRevenueInsightSegmentationSegmentationMetricBlockBarLoading =
  <template>
    <div class="ml-400 flex w-full flex-col justify-center">
      <div class="flex w-full justify-between">
        <div class="segmentation-value-loading-state-bar"></div>
        <div class="segmentation-value-loading-state-bar"></div>
      </div>
      <div
        class="segmentation-value-loading-state-bar long value-spacing"
      ></div>
    </div>
  </template> satisfies TOC<HotelAndMarketRevenueInsightSegmentationSegmentationMetricBlockBarLoadingSignature>;

export default HotelAndMarketRevenueInsightSegmentationSegmentationMetricBlockBarLoading;
